import Videos from "./partials/Videos";
import "./VideosList.css";

const VideosList = () => {
  return (
    <div className="videos-list-section">
      <Videos />
    </div>
  );
};

export default VideosList;
